/**
 * useCompletedRituals Hook
 * Fetches completed rituals for the Latest Rituals section.
 */

import { useQuery } from "@tanstack/react-query"
import { getCompletedRituals } from "../services/my-rituality.service"

export function useCompletedRituals(userId: string, options?: { limit?: number }) {
  return useQuery({
    queryKey: ["completedRituals", userId, options?.limit],
    queryFn: () => getCompletedRituals(userId, { page: 1, limit: options?.limit || 4 }),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
